// An object that can be used to manipulate breadcrumbs using JS
window.Breadcrumbs = (function ($) {
  var containerSelector = ".breadcrumbs ul";
  var breadcrumbSelector = ".breadcrumbs ul li";

  // PUBLIC INTERFACE

  return { push: push, pop: pop };

  // HELPER FUNCTIONS

  function push(content, href) {
    jQuery(containerSelector).append(buildBreadcrumb(content, href));
  }

  // Removes the last breadcrumb unless it is the only remaining breadcrumb
  // in which case it is the "Home" breadcrumb
  function pop() {
    var breadcrumbs = jQuery(breadcrumbSelector);
    if (breadcrumbs.length > 1) {
      jQuery(breadcrumbSelector).last().remove();
    }
  }

  function buildBreadcrumb(content, href) {
    var link = jQuery("<a></a>").html(content).attr("href", href);
    return jQuery("<li></li>").append(link);
  }
})(jQuery);
